import { ReactElement, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ElementProps } from "../../functionalComponents/RenderPage";
import { createLocation, PageElementsFamily } from "../../state/page";
import { AutoSpaceAtom } from "../../state/ui";

const AutoSpace = function({ atomId, pageIndex }: ElementProps): ReactElement<ElementProps> {
  const key = createLocation(pageIndex, atomId);
  const elementData = useRecoilValue(PageElementsFamily(key)).data;
  const setAutoSpaceAtom = useSetRecoilState(AutoSpaceAtom);

  useEffect(() => {
    if (elementData.type !== "autospace:") return;
    const autoSpace = elementData.content && typeof elementData.content === "string"
      ? elementData.content
      : "on";

    setAutoSpaceAtom(autoSpace === "off" ? false : true);
  });
  return <></>;
};

export default AutoSpace;
